export default function getSubdomain() {
  let subdomain = window.location.host;

  subdomain = subdomain.split(':')[0]; // Get rid of port.
  subdomain = subdomain.split('.')[0]; // Get rid of subdomain (www

  return subdomain !== process.env.REACT_APP_HOST ? subdomain : '';
}
